export default "__VITE_ASSET__CdjQTaFF__"